import { resolveApiOrigin } from '@vipso/shared';
import {
  resolveTenantDefaultLogoUrl,
  VIPSO_TENANT_BRAND,
} from '../brand/tenantBrandDefaults';
import type { TenantConfig, TenantTheme } from '../store/authSlice';
import { resolveTenantSlug } from './tenant';

/** @deprecated Prefer resolveTenantDefaultLogoUrl(slug). VIPSo bundled mark. */
export const DEFAULT_BRAND_LOGO = VIPSO_TENANT_BRAND.logoUrl;

/** Minimal org shape for logo display (OrgInfo / TenantOrgOption). */
export type OrgLogoSource = {
  logoFileId?: string | number | null;
  logoUrl?: string | null;
};

export type ResolveDisplayLogoOptions = {
  /** Tenant slug; defaults to `resolveTenantSlug()`. */
  tenantSlug?: string | null;
};

/**
 * Company logo when the org has a logoFileId; otherwise the bundled tenant default.
 * Tenant config/theme remote URLs are ignored for display.
 */
export function resolveDisplayLogoUrl(
  org?: OrgLogoSource | null,
  _config?: TenantConfig | null,
  _theme?: TenantTheme | null,
  options?: ResolveDisplayLogoOptions,
): string {
  const tenantLogo = resolveTenantDefaultLogoUrl(
    options?.tenantSlug ?? resolveTenantSlug(),
  );
  const orgLogoId = org?.logoFileId;
  const orgHasLogo = orgLogoId != null && String(orgLogoId).trim() !== '';
  if (orgHasLogo) {
    return absolutizePublicAsset(org?.logoUrl ?? null) ?? tenantLogo;
  }
  return tenantLogo;
}

export function absolutizePublicAsset(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('data:') || url.startsWith('blob:')) return url;
  if (url.startsWith('/api/files/')) {
    try {
      const origin = resolveApiOrigin().replace(/\/$/, '');
      if (origin) return `${origin}${url}`;
    } catch {
      /* fall through */
    }
  }
  return url;
}

export { resolveTenantDefaultLogoUrl } from '../brand/tenantBrandDefaults';
